.root {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  padding-top: 1px;
  margin-right: 0.5rem;
  line-height: 1.5rem;
  color: white;
  text-align: center;
  background: var(--gray-900);
  border-radius: 1rem;
  transition: all var(--animation-duration);

  [data-state="open"] > * > & {
    opacity: 0;
    transform: scale(0.85);
  }
}
